import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./AdminCategories.css";
import Modal from "../../components/Modal";
const AdminCategories = () => {
  const { token } = useSelector((state) => state.auth);

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);

  const initialFormState = {
    name: "",
    slug: "",
    image: "",
    parent_id: "0",
    status: "1", 
  };

  const [formData, setFormData] = useState(initialFormState);

  // Edit Category State
  const [editingCategoryId, setEditingCategoryId] = useState(null);
  const [editFormData, setEditFormData] = useState({
    name: "",
    slug: "",
    image: "",
    parent_id: "0",
    status: "1",
  });

  // 1. Fetch All Categories
  const fetchCategories = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await fetch(
        "https://rbuymart.rbhardwaj.com/server/api/admin/categories.php",
      );
      if (!res.ok) throw new Error("Failed to fetch categories.");

      const result = await res.json();
      if (result.status === "success" && Array.isArray(result.data)) {
        setCategories(result.data);
      } else if (Array.isArray(result)) {
        setCategories(result);
      } else {
        setCategories([]);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // Handle Form Input Changes
  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleEditInputChange = (e) => {
    setEditFormData({ ...editFormData, [e.target.name]: e.target.value });
  };

 
  const formatPayload = (data) => {
    const parentVal = Number(data.parent_id);
    return {
      ...data,
      name: data.name.trim(),
      slug: data.slug.trim(),
      parent_id: parentVal > 0 ? parentVal : null, 
      status: Number(data.status),
    };
  };

  // 2. Add New Category
  const handleAddCategory = async (e) => {
    e.preventDefault();
    if (!formData.name.trim()) return;

    try {
      setSubmitting(true);
      const res = await fetch(
        "https://rbuymart.rbhardwaj.com/server/api/admin/categories.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formatPayload(formData)),
        },
      );

      const data = await res.json();
      if (res.ok && data.status === "success") {
        setFormData(initialFormState);
        fetchCategories(); // Refresh List
      } else {
        alert(data.message || "Error adding category.");
      }
    } catch (err) {
      alert("Server error while adding category.");
    } finally {
      setSubmitting(false);
    }
  };

  // Start Editing
  const handleStartEdit = (cat) => {
    setEditingCategoryId(cat.id);
    setEditFormData({
      name: cat.name || "",
      slug: cat.slug || "",
      image: cat.image || "",
      parent_id: cat.parent_id ? String(cat.parent_id) : "0",
      status: String(cat.status ?? "1"),
    });
  };

  // 3. Update Category
  const handleUpdateCategory = async (id) => {
    if (!editFormData.name.trim()) return;

    try {
      setSubmitting(true);
      const res = await fetch(
        "https://rbuymart.rbhardwaj.com/server/api/admin/categories.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            id,
            ...formatPayload(editFormData),
          }),
        },
      );

      const data = await res.json();
      if (res.ok && data.status === "success") {
        setEditingCategoryId(null);
        fetchCategories();
      } else {
        alert(data.message || "Failed to update category.");
      }
    } catch (err) {
      alert("Error updating category.");
    } finally {
      setSubmitting(false);
    }
  };

  // 4. Delete Category
  const handleDeleteCategory = async (id) => {
    if (!window.confirm("Are you sure you want to delete this category?"))
      return;

    try {
      const res = await fetch(
        `https://rbuymart.rbhardwaj.com/server/api/admin/categories.php?id=${id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await res.json();
      if (res.ok && data.status === "success") {
        fetchCategories();
      } else {
        alert(data.message || "Failed to delete category.");
      }
    } catch (err) {
      alert("Error deleting category.");
    }
  };

  // Helper function to resolve Parent Name for UI
  const getParentName = (parentId) => {
    if (!parentId || Number(parentId) === 0) return "Main Category";
    const parent = categories.find((c) => String(c.id) === String(parentId));
    return parent ? parent.name : `Parent #${parentId}`;
  };

  return (
    <div className="admin-categories-page">
      <div class="admin-header-tap">
        <h3>Category</h3>
        <div className="flex-div">
          <button onClick={() => setOpen(true)} className="btn-add">
             <i class="material-icons">&#xe146;</i> Add
          </button>
          <button onClick={() => window.print()} className="btn-print">
            <i className="material-icons">&#xe8ad;</i> Print
          </button>
        </div>
      </div>

      <Modal isOpen={open} onClose={() => setOpen(false)} title="Add Category">
        <form onSubmit={handleAddCategory} className="category-form">
        
            <div className="formlabeldiv">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
              <label htmlFor="">Category Name</label>
            </div>
            <div className="formlabeldiv">
              <input
                type="text"
                name="slug"
             
                value={formData.slug}
                onChange={handleInputChange}
              />
                    <label htmlFor="">Slug (Optional)</label>
            </div>
    

        
            <div className="formlabeldiv">
              <input
                type="text"
                name="image"
          
                value={formData.image}
                onChange={handleInputChange}
              />
                     <label htmlFor="">Image URL (Optional)</label>
            </div>

            <div className="formlabeldiv">
              <select
                name="parent_id"
                value={formData.parent_id}
                onChange={handleInputChange}
              >
                <option value="0">-- Main Category (No Parent) --</option>
                {categories.map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.name}
                  </option>
                ))}
              </select>
                 <label htmlFor="">Parent Id</label>
            </div>

            <div className="formlabeldiv">
              <select
                name="status"
                value={formData.status}
                onChange={handleInputChange}
              >
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
               <label htmlFor="">status</label>
            </div>
  

          <button type="submit" className="btn-submit" disabled={submitting}>
            {submitting ? "Processing..." : "Add Category"}
          </button>
        </form>
      </Modal>

      {/* Categories Table */}
      <div className="table-div">
        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p className="error-text">{error}</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Image</th>
                <th>Category Name</th>
                <th>Slug</th>
                <th>Parent Category</th>
                <th>Status</th>
                <th colSpan={2}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {categories.length === 0 ? (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center" }}>
                    No categories found.
                  </td>
                </tr>
              ) : (
                categories.map((cat) => {
                  const isEditing = editingCategoryId === cat.id;

                  return (
                    <tr key={cat.id}>
                      <td>{cat.id}</td>

                      {/* Image Field */}
                      <td>
                        {isEditing ? (
                          <input
                            type="text"
                            name="image"
                            value={editFormData.image}
                            onChange={handleEditInputChange}
                            placeholder="Image URL"
                          />
                        ) : cat.image ? (
                          <img
                            src={cat.image}
                            alt={cat.name}
                            style={{
                              width: "40px",
                              height: "40px",
                              objectFit: "cover",
                              borderRadius: "4px",
                            }}
                          />
                        ) : (
                          "N/A"
                        )}
                      </td>

                      {/* Name Field */}
                      <td>
                        {isEditing ? (
                          <input
                            type="text"
                            name="name"
                            value={editFormData.name}
                            onChange={handleEditInputChange}
                          />
                        ) : (
                          <strong>{cat.name}</strong>
                        )}
                      </td>

                      {/* Slug Field */}
                      <td>
                        {isEditing ? (
                          <input
                            type="text"
                            name="slug"
                            value={editFormData.slug}
                            onChange={handleEditInputChange}
                          />
                        ) : (
                          cat.slug
                        )}
                      </td>

                      {/* Parent Category Field */}
                      <td>
                        {isEditing ? (
                          <select
                            name="parent_id"
                            value={editFormData.parent_id}
                            onChange={handleEditInputChange}
                          >
                            <option value="0">None (Main)</option>
                            {categories
                              .filter((c) => c.id !== cat.id)
                              .map((c) => (
                                <option key={c.id} value={c.id}>
                                  {c.name}
                                </option>
                              ))}
                          </select>
                        ) : (
                          getParentName(cat.parent_id)
                        )}
                      </td>

                      {/* Status Field */}
                      <td>
                        {isEditing ? (
                          <select
                            name="status"
                            value={editFormData.status}
                            onChange={handleEditInputChange}
                          >
                            <option value="1">Active</option>
                            <option value="0">Inactive</option>
                          </select>
                        ) : (
                          <span
                            className={`badge badge-${
                              Number(cat.status) === 1 ? "active" : "inactive"
                            }`}
                          >
                            {Number(cat.status) === 1 ? "Active" : "Inactive"}
                          </span>
                        )}
                      </td>

                      {/* Actions */}

                      {isEditing ? (
                        <>
                          <td>
                            <button
                              className="btn-save"
                              onClick={() => handleUpdateCategory(cat.id)}
                              disabled={submitting}
                            >
                              <i class="material-icons">&#xe161;</i> Save
                            </button>
                          </td>
                          <td>
                            {" "}
                            <button
                              className="btn-delete"
                              onClick={() => setEditingCategoryId(null)}
                            >
                              <i class="material-icons">&#xe5c9;</i> Cancel
                            </button>
                          </td>
                        </>
                      ) : (
                        <>
                          <td>
                            {" "}
                            <button
                              className="btn-edit"
                              onClick={() => handleStartEdit(cat)}
                            >
                              <i className="material-icons">&#xe3c9;</i> Edit
                            </button>
                          </td>
                          <td>
                            {" "}
                            <button
                              className="btn-delete"
                              onClick={() => handleDeleteCategory(cat.id)}
                            >
                              <i className="material-icons">&#xe872;</i> Delete
                            </button>
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminCategories;
